var map = {
	"./AdminApp.vue": 4332,
	"./App.vue": 3300,
	"./admin/components/buttons/ButtonComponent.vue": 8680,
	"./admin/components/buttons/ButtonStatusComponent.vue": 9664,
	"./admin/components/buttons/DownloadPillComponent.vue": 9181,
	"./admin/components/inputs/CheckboxComponent.vue": 501,
	"./admin/components/inputs/DropdownComponent.vue": 9760,
	"./admin/components/inputs/FileUploadComponent.vue": 3990,
	"./admin/components/inputs/InputComponent.vue": 7025,
	"./admin/components/inputs/SearchComponent.vue": 3334,
	"./admin/components/misc/AppropriatenessScorePillComponent.vue": 9421,
	"./admin/components/misc/DataTableComponent.vue": 3559,
	"./admin/components/misc/HeadingBarComponent.vue": 1119,
	"./admin/components/misc/HrComponent.vue": 8403,
	"./admin/components/misc/StatusBadgeComponent.vue": 6581,
	"./admin/components/modals/ApprovalModalComponent.vue": 7132,
	"./admin/components/partials/HeaderComponent.vue": 7392,
	"./admin/components/partials/SidebarComponent.vue": 9305,
	"./admin/components/partials/submission-details/ApprovalInformationComponent.vue": 618,
	"./admin/components/partials/submission-details/BankingDetailsComponent.vue": 3102,
	"./admin/components/partials/submission-details/DeclarationsComponent.vue": 159,
	"./admin/components/partials/submission-details/EmploymentDetailsComponent.vue": 2606,
	"./admin/components/partials/submission-details/FinancialCircumstancesComponent.vue": 1306,
	"./admin/components/partials/submission-details/InvestmentExperienceComponent.vue": 7139,
	"./admin/components/partials/submission-details/InvestmentObjectivesComponent.vue": 1234,
	"./admin/components/partials/submission-details/LegalDocumentationComponent.vue": 2257,
	"./admin/components/partials/submission-details/PersonalDetailsComponent.vue": 167,
	"./admin/components/partials/submission-details/SubmissionStatusOverviewComponent.vue": 8037,
	"./admin/pages/AdminDashboardPage.vue": 8554,
	"./admin/pages/AdminUserSubmissionPage.vue": 8616,
	"./components/buttons/AddNewButtonComponent.vue": 8270,
	"./components/buttons/ButtonComponent.vue": 9712,
	"./components/forms/BankingDetailsFormComponent.vue": 9903,
	"./components/forms/DeclarationsFormComponent.vue": 6312,
	"./components/forms/EmploymentDetailsFormComponent.vue": 3292,
	"./components/forms/FinancialCircumstancesFormComponent.vue": 4793,
	"./components/forms/InvestmentExperienceFormComponent.vue": 4377,
	"./components/forms/InvestmentObjectivesFormComponent.vue": 8221,
	"./components/forms/LegalDocumentationFormComponent.vue": 1406,
	"./components/forms/POADocumentFormComponent.vue": 1307,
	"./components/forms/POIDocumentFormComponent.vue": 3551,
	"./components/forms/POISelfieFormComponent.vue": 1846,
	"./components/forms/PersonalDetailsFormComponent.vue": 4358,
	"./components/inputs/CheckboxComponent.vue": 1020,
	"./components/inputs/ConfirmationComponent.vue": 7904,
	"./components/inputs/DatepickerComponent.vue": 5958,
	"./components/inputs/DropdownComponent.vue": 2654,
	"./components/inputs/FileUploadComponent.vue": 7092,
	"./components/inputs/InputComponent.vue": 35,
	"./components/inputs/NumberInputComponent.vue": 3612,
	"./components/inputs/ScaleSliderComponent.vue": 9080,
	"./components/inputs/TelephoneComponent.vue": 8011,
	"./components/inputs/YesNoQuestionComponent.vue": 6393,
	"./components/inputs/YesNoSliderComponent.vue": 8956,
	"./components/misc/AccordionComponent.vue": 6086,
	"./components/misc/AlertComponent.vue": 6614,
	"./components/misc/HintComponent.vue": 714,
	"./components/misc/StepperComponent.vue": 115,
	"./components/partials/GlobalLoaderComponent.vue": 8602,
	"./components/partials/HeaderComponent.vue": 6623,
	"./components/partials/StepNavigationComponent.vue": 219,
	"./components/partials/SubmissionErrorsModalComponent.vue": 8480,
	"./components/partials/SubmissionSuccessModalComponent.vue": 8255,
	"./pages/account/CreateAccountPage.vue": 7288,
	"./pages/account/SubmissionSuccessPage.vue": 3639,
	"./pages/auth/EmailVerifiedPage.vue": 4109,
	"./pages/auth/ForgotPasswordPage.vue": 3817,
	"./pages/auth/LoginPage.vue": 4929,
	"./pages/auth/PasswordResetPage.vue": 5995,
	"./pages/auth/RegisterPage.vue": 6268,
	"./pages/errors/Error404Page.vue": 9129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4288;